export default __webpack_public_path__ + "static/media/logo.a4e5f1ad.png";